import React from "react";

export const Logo: React.FC = () => (
  <svg
    width="34"
    height="34"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="32" height="32" rx="16" fill="#E7EB5D" />
    <path
      d="M16.2248 11.788L18.4627 5.89193L18.0595 5.31494H13.8924L13.4928 5.89193L15.7489 11.7989L15.3492 12.3831H13.4674L13.1622 12.5057L11.6799 13.977L11.5709 14.3989L15.5672 26.6852C15.9887 26.6852 15.956 26.6852 16.3774 26.6852L20.3737 14.4242L20.2683 13.9878L18.7897 12.5237L18.4845 12.3831H16.6281L16.2248 11.788Z"
      fill="black"
    />
  </svg>
);

export default Logo;
